import React, { useState } from 'react';
import ClientDocumentReport from '../components/ClientDocumentReport';
import DocumentDataDashboard from '../components/DocumentDataDashboard';

const TABS = [
  { key: 'report', label: 'eMoney report', icon: 'bi-person-lines-fill' },
  { key: 'all', label: 'All extractions', icon: 'bi-list-ul' },
];

/**
 * eMoney Build page (route /document-data, permission document_data -- kept
 * under their original names so bookmarks and granted permissions still work)
 *
 * eMoney report: one client's analyzed documents grouped in eMoney entry
 * order, with extracted data points, summaries, source links and an Ask box.
 * All extractions: every extracted document across clients.
 */
const DocumentData = () => {
  const [tab, setTab] = useState('report');

  return (
    <div className="container-fluid py-3">
      <div className="d-flex align-items-center mb-3">
        <h4 className="mb-0">
          <i className="bi bi-table me-2"></i>
          eMoney Build
        </h4>
      </div>
      <ul className="nav nav-tabs" role="tablist">
        {TABS.map(({ key, label, icon }) => (
          <li className="nav-item" key={key} role="presentation">
            <button
              type="button"
              role="tab"
              aria-selected={tab === key}
              className={`nav-link ${tab === key ? 'active' : ''}`}
              onClick={() => setTab(key)}
            >
              <i className={`bi ${icon} me-1`}></i>{label}
            </button>
          </li>
        ))}
      </ul>
      <div className="card border-top-0 rounded-top-0">
        <div className="card-body">
          {tab === 'report' ? <ClientDocumentReport /> : <DocumentDataDashboard />}
        </div>
      </div>
    </div>
  );
};

export default DocumentData;
